import styled from 'styled-components';

export const ListItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
  border: 1px solid transparent;

  &:hover {
    background: ${(props) => props.theme.colors.backgroundSecondary || '#F9FAFB'};
    border-color: ${(props) => props.theme.colors.border || '#E5E7EB'};
  }
`;

export const ListItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
`;

export const ListItemTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text || '#1F2937'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ListItemPreview = styled.div`
  font-size: 13px;
  color: ${(props) => props.theme.colors.textSecondary || '#6B7280'};
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const ListItemMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ListItemMetaText = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.colors.textSecondary || '#9CA3AF'};
  font-weight: 500;
`;

export const ListItemTags = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

export const Tag = styled.span`
  padding: 2px 6px;
  background: ${(props) => props.theme.colors.primaryLight || '#EEF2FF'};
  color: ${(props) => props.theme.colors.primary || '#4F46E5'};
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.colors.textSecondary || '#9CA3AF'};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0;

  ${ListItemContainer}:hover & {
    opacity: 1;
  }

  &:hover {
    background: #FEE2E2;
    color: #DC2626;
  }
`;

